import AvailableRoom from "../interfaces/availableRoom";
import Room from "../interfaces/room";
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export interface RoomState {
    availableRooms: AvailableRoom[],
    rooms: Room[],
    hasCustomSelection: boolean,
    isRestored: boolean
}

export const initialRoomState: RoomState = {
    availableRooms: [],
    rooms: [],
    hasCustomSelection: false,
    isRestored: false
}

export default {
    namespaced: false,
    state: initialRoomState,
    mutations,
    actions,
    getters
}
